import { c as _c } from "react/compiler-runtime";
import createSelectProductQuantityInCarts, { ProductQuantityPerCart } from '../../store/carts/selectors/createSelectProductQuantityInCarts';
import { shallowEqual, useSelector } from 'react-redux';
import { useMemo } from 'react';
const useSelectProductQuantityInCarts = productCode => {
  const $ = _c(2);
  let t0;
  if ($[0] !== productCode) {
    t0 = createSelectProductQuantityInCarts(productCode);
    $[0] = productCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selector = t0;
  return useSelector(selector, shallowEqual);
};
export default useSelectProductQuantityInCarts;